import { Result } from 'antd';
import {t} from 'i18next';

const Page404 = () => {
    return <Result
    status="404"
    title="404"
    subTitle={t('page.404')}
    />
}

export default Page404;
